import Vue from 'vue'
import App from './App.vue'
import router from './router'
import pinia from '@/store'
import { PiniaVuePlugin } from 'pinia'
import './filter'
import Antd from 'ant-design-vue'
import { registerMicroApps, start, initGlobalState, MicroAppStateActions, setDefaultMountApp } from 'qiankun'
import { apps, excludeAssetFilter, state } from '../micro/config'
import { HALL_ACTIVE_RULE } from '../../../micro/config'
import { useUserStore } from '@/store/user'
import { useMenuStore } from '@/store/menu'
import config from '@/config'
import { api } from '@/api'
import { GlobalActions } from '@/util/enum'
import { setToken } from '@/util/auth'
import 'ant-design-vue/dist/antd.less'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import './style'

Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(Viewer)
Vue.prototype.$config = config
Vue.prototype.$http = api

registerMicroApps(apps)
setDefaultMountApp(HALL_ACTIVE_RULE)
//启动qiankun
start({
  excludeAssetFilter,
})
const log = (...info) => {
  // eslint-disable-next-line no-console
  console.log('%c[main-micro]', 'color: #fff;background-color:#108ee9; padding: 2px;', ...info)
}
const userStore = useUserStore(pinia)
const menuStore = useMenuStore(pinia)
Vue.use(PiniaVuePlugin)

// 初始化 state
const actions: MicroAppStateActions = initGlobalState(state)
actions.onGlobalStateChange((state) => {
  log('onGlobalStateChange:', state)
  switch (state.action) {
    case GlobalActions.SignIn:
      log('SignIn')
      setToken(state.token)
      userStore.setInfo(state.userInfo)
      userStore.setToken(state.token)
      userStore.logged(state.token)
      break
    case GlobalActions.SignOut:
      log('SignOut')
      userStore.setToken('')
      userStore.logout()
      menuStore.clear()
      window.history.pushState(null, '', '/hall')
      break
    case GlobalActions.InitMenu:
      menuStore.init({
        menus: state.menus,
        buttons: state.buttons,
      })
  }
})

Vue.prototype.$setGlobalState = actions.setGlobalState

new Vue({
  router,
  render: (h) => h(App),
  pinia,
}).$mount('#app')
